module.exports = __webpack_public_path__ + "static/media/8 Between The Wars.c4ecfb73.mp3";